















































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import SubMenuTemplate from '@/views/SubMenuTemplate.vue';
import {Timeline, TimelineItem, TimelineOptions} from 'vis-timeline/esnext';
import 'vis-timeline/dist/vis-timeline-graph2d.min.css';
import moment, {MomentFormatSpecification, MomentInput} from 'moment';
import Axios, {AxiosResponse, CancelTokenSource} from 'axios';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import FormTemplate from '@/views/formular/FormTemplate.vue';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import DataTableListTemplate from '@/views/datatable/DataTableListTemplate.vue';
import {DataSet} from 'vis-data/esnext';
import {DatePatterns} from '@/utils/date.patterns';
import {cloneDeep, debounce, isEqual, orderBy, set} from 'lodash';
import TimelineFilterPanelTemplate from '@/views/timeline/views/TimelineFilterPanelTemplate.vue';
import TimelineLegend from '@/views/timeline/views/TimelineLegend.vue';
import {ResizeSensor} from 'css-element-queries';
import {DOCUMENT_SCROLL_SERVICE_INSTANCE} from '@/services/documentscroll.service';
import AmetrasResponsiveTabBar from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import AmetrasDynamicContentDialog from '@/views/AmetrasDynamicContentDialog.vue';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {SubmenuClosePayload, SubMenuConfig} from '@/interfaces/submenu.interface';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import {ToolbarButtonClickedEventData} from '@/views/AmetrasDynamicContent.vue';

import Holidays, {HolidaysTypes} from 'date-holidays';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import TimelineHolidayPanelTemplate from '@/views/timeline/views/TimelineHolidayPanelTemplate.vue';
import {AMETRAS_HOLIDAY_UTILS_INST, ExtendedHolidays} from '@/services/holiday.service';
import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';
import {MechanicOnlineStatusFeature} from '@/views/timeline/features/mechanic-online-status-feature';
import {FormularInstance} from '@/views/formular/form.interface';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';
import {MechanicRestWorkingHoursFeature} from '@/views/timeline/features/mechanic-rest-working-hours-feature';
import {TimelineLifeCycleFeature} from '@/views/timeline/features/timeline-life-cycle-feature';
import AdvancedConfirmDialog, {ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';

interface TimelineDialogType {
  key: string | number; // a string or number defining whether the dialog must be re-rendered
  create: boolean;
  editKey?: CompositeKeyType;
  overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
  onApply?: () => void;
  onAbort?: () => void;
  dialogTitle?: string;
  content?: DisguiseDto.DynamicContentUnion;
  tabRenderKeyCount?: number;
  formularInstance?: FormularInstance;
  maxWidth?: string;
  fullscreen?: boolean;
}

interface ContextMenuType {
  positionX: number;
  positionY: number;
  items: DisguiseDto.TimelineContextMenuItemAction[];
  originalEvent: any;
}

interface TimelineSubmenuData {
  '@type': 'REOPEN_DIALOG';
}

interface TimelineReopenDialogSubmenuData extends TimelineSubmenuData {
  '@type': 'REOPEN_DIALOG';
  dialog?: TimelineDialogType;
}

@Component({
  components: {
    AdvancedConfirmDialog,
    TimelineHolidayPanelTemplate,
    AmetrasSelectFieldTemplate,
    AmetrasDynamicContentDialog,
    AmetrasResponsiveTabBar,
    TimelineLegend,
    TimelineFilterPanelTemplate,
    DataTableListTemplate,
    FormTemplate,
    SubMenuTemplate,
  }
})

export default class TimelineTemplateV2 extends Vue {
  @Prop() endpointUrl!: string;
  @Prop({
    default: null
  }) userRequestedReload!: BehaviorSubject<string> | null;
  @Prop({
    default: true
  }) reloadOnUserRequest!: boolean; // defined by navi service

  iconService: IconsService = ICONS_SERVICE_INSTANCE;

  fabButtons: DisguiseDto.TimelineFabButton[] = [];
  openedFabButtons: {} = {};
  dialog: TimelineDialogType | null = null;
  timelineFilters: DisguiseDto.TimelineFilterDto[] = [];
  initialLoadCompleted = false; // required to prevent filter watch during init phase
  loading: boolean = false;
  showDialog: boolean = false;
  panels: DisguiseDto.TimelinePanelsDto | null = null;
  northHeight: number = 0;
  southHeight: number = 0;
  filterConfiguration: DisguiseDto.TimelineFilterConfigurationDto[] = [];
  originalDocumentScrollXOffset: number = 0;
  showContextMenu: boolean = false;
  dialogKey: number = 0; // current :key property of v-dialog
  contextMenu: ContextMenuType = {
    positionX: 0,
    positionY: 0,
    items: [],
    originalEvent: null
  };

  locations: Location[] = [];

  subMenu: SubMenuConfig | null = null;

  $refs!: {
    timeline: HTMLDivElement,
    northPanel: HTMLDivElement,
    southPanel: HTMLDivElement
  };

  submitFiltersOnUserRequest: boolean = false;
  currentHolidaySelection: ExtendedHolidays | null = null;
  darkColors: { [p: string]: string } = {};
  lightColors: { [p: string]: string } = {};
  globalStylingVariables: { [p: string]: string } = {};

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;

  private timelineOffsetTop: number = 0;  // time axis top offset

  private timeline: Timeline | null = null; // the timeline instance

  private floatingTableHeader: HTMLElement | null = null;
  private floatingGroupBar: HTMLElement | null = null;
  private timelineOptions: TimelineOptions | null = null;
  private cancelToken: CancelTokenSource = Axios.CancelToken.source();
  private timelineGroups: DisguiseDto.TimelineGroupDto[] = [];
  private timelineLocations: DisguiseDto.GLocInputDto[] = [];

  private showLegend: boolean = false;
  private originalApiResponse: DisguiseDto.TimelineDto | undefined;

  // last search start date. if different to the current one, the scroll bar will be reset
  private lastStartDate: Date | number | string | undefined;
  private holidays: Holidays | null = AMETRAS_HOLIDAY_UTILS_INST.getHolidays();
  private indexedHolidaysForViewRange: { [isoFormattedDate: string]: string } = {};

  private EXCLUDED_HOLIDAY_TYPES: HolidaysTypes.HolidayType[] = ['observance'];

  private registeredGlobalEventListenerNames: string[] = [];

  private initializedFeatures: TimelineLifeCycleFeature[] = [];

  private userRequestedReloadSubscription: Subscription | undefined;
  private lastUserRequestedReloadReqId: string = '';

  private debouncedLoadData = debounce(() => {
    this.loadData(undefined, this.dialog?.create);
  }, 200);
  private timelineGroupsDataSet: DataSet<any> | undefined;

  @Watch('timelineFilters', {deep: true}) onFilterChanged() {
    if (!this.submitFiltersOnUserRequest && this.initialLoadCompleted) {
      this.debouncedLoadData();
    }
  }

  @Watch('$store.state.navigation.isLocked') onNavigationShowToggled() {
    // reposition group bar after navigation toggled
    this.repositionFixedTableHeader();
  }

  @Watch('userRequestedReload') userRequestedReloadChanged() {
    this.bindToReload();
  }

  beforeMount() {
    // register scroll listener
    window.addEventListener('scroll', this.repositionFixedTableHeader);
  }

  mounted() {
    // initialize after DOM element with ref timeline is rendered
    this.$nextTick(() => {
      this.initialize();
    });
    this.bindToReload();
  }

  beforeDestroy() {
    this.destroyFeatures();
    // unregister scroll listener
    window.removeEventListener('scroll', this.repositionFixedTableHeader);
    if (this.timeline) {
      this.timeline.destroy();
    }
    this.cancelToken.cancel();
  }

  // user requested filter application manually
  onFilterSubmit() {
    this.loadData(undefined, this.dialog?.create);
  }

  afterFormularInitialized(formularInstance: FormularInstance, dialog: TimelineDialogType) {
    this.$set(dialog, 'formularInstance', formularInstance);
  }

  afterFormularModified(response: DisguiseDto.TimelineModifyResponseDto) {
    this.loadData(response, this.dialog?.create || false);

    if (this.dialog?.onApply) {
      this.dialog.onApply();
    }
    if (this.timeline) {
      this.timeline.setSelection([]);
    }
    this.dialog = null;
    this.closeDialog();
  }

  initialize() {
    // set the axis top offset. so that it appears floating and always on top
    this.timelineOffsetTop = this.$refs.timeline.getBoundingClientRect().top;
    this.loadData();
  }

  onContextMenuActionClicked(action: DisguiseDto.ITimelineItemActionUnion, contextMenu: ContextMenuType) {
    this.contextMenu = {
      positionX: 0,
      positionY: 0,
      originalEvent: null,
      items: []
    };
    this.showContextMenu = false;
    this.onEmptyAreaClick(action, contextMenu.originalEvent);
  }

  onFabButtonChildClick(button: DisguiseDto.TimelineButtonAction) {
    if (button['@type'] === 'SETTINGS') {
      const castedButton = button as DisguiseDto.TimelineSettingsAction;
      if (this.timeline && this.timelineOptions) {
        if (castedButton.active) {
          // @ts-ignore
          this.timelineOptions = {
            ...this.timelineOptions,
            ...castedButton.settingOnDeactivate || {},
          };
          // @ts-ignore
          this.timeline.setOptions(this.timelineOptions);
          castedButton.active = false;
        } else {
          // @ts-ignore
          this.timelineOptions = {
            ...this.timelineOptions,
            ...castedButton.settingOnActivate || {},
          };
          // @ts-ignore
          this.timeline.setOptions(this.timelineOptions);
          castedButton.active = true;
        }
      }
    } else if (button['@type'] === 'FILTER') {
      const castedButton = button as DisguiseDto.TimelineFilterAction;
      if (castedButton.active && castedButton.filterOnDeactivate && castedButton.filterOnDeactivate.filterId) {
        const filterIndex = this.lookupFilterIndex(castedButton.filterOnDeactivate);
        if (filterIndex > -1) {
          this.timelineFilters[filterIndex] = castedButton.filterOnDeactivate;
          this.$set(this.timelineFilters, filterIndex, this.timelineFilters[filterIndex]);
        }
        castedButton.active = false;
      } else if (castedButton.active && castedButton.filtersOnDeactivate && castedButton.filtersOnDeactivate.length > 0) {
        const newFilterSetting = cloneDeep(this.timelineFilters);
        for (const currentFilter of castedButton.filtersOnDeactivate) {
          const filterIndex = this.lookupFilterIndex(currentFilter);
          if (filterIndex > -1) {
            newFilterSetting[filterIndex] = currentFilter;
          }
        }

        if (!isEqual(this.timelineFilters, newFilterSetting)) {
          this.timelineFilters = newFilterSetting;
        }

        castedButton.active = false;
      } else if (castedButton.filterOnActivate && castedButton.filterOnActivate.filterId) {
        const filterIndex = this.lookupFilterIndex(castedButton.filterOnActivate);
        if (filterIndex > -1) {
          this.timelineFilters[filterIndex] = castedButton.filterOnActivate;
          this.$set(this.timelineFilters, filterIndex, this.timelineFilters[filterIndex]);
        }
        castedButton.active = true;
      } else if (castedButton.filtersOnActivate && castedButton.filtersOnActivate.length > 0) {
        const newFilterSetting = cloneDeep(this.timelineFilters);

        if (castedButton.filtersOnActivate && castedButton.filtersOnActivate.length > 0) {
          for (const currentFilter of castedButton.filtersOnActivate) {
            const filterIndex = this.lookupFilterIndex(currentFilter);
            if (filterIndex > -1) {
              newFilterSetting[filterIndex] = currentFilter;
            }
          }
        }

        if (!isEqual(this.timelineFilters, newFilterSetting)) {
          this.timelineFilters = newFilterSetting;
        }

        castedButton.active = true;
      }
    } else if (button['@type'] === 'TimelineDialogAction') {
      const castedButton = button as DisguiseDto.TimelineDialogAction;
      if (castedButton.formular) {
        const overwrittenFields:
            { [fieldName: string]: DisguiseDto.FTFieldDto } = {};

        overwrittenFields.maps = {
          type: 'FTFieldDto',
          value: JSON.stringify(this.timelineLocations)
        };

        this.dialog = {
          key: this.dialogKey++,
          dialogTitle: castedButton.dialogTitle || '',
          create: true,
          content: castedButton.formular,
          overwrittenFields,
          maxWidth: castedButton.maxWidth
        };
        this.openDialog();
      }
    } else if (button['@type'] === 'PANEL') {
      const castedButton = button as DisguiseDto.TimelinePanelButtonAction;
      if (castedButton.side) {
        let panelSideToToggle;
        switch (castedButton.side) {
          case 'EAST': {
            panelSideToToggle = this.panels?.east;
            break;
          }
          case 'NORTH': {
            panelSideToToggle = this.panels?.north;
            break;
          }
          case 'SOUTH': {
            panelSideToToggle = this.panels?.south;
            break;
          }
          default: {
            break;
          }
        }
        if (panelSideToToggle) {
          panelSideToToggle.show = !panelSideToToggle.show;
          this.resizeNorth();
          this.resizeSouth();
        }
      }
    } else if (button['@type'] === 'LEGEND') {
      this.showLegend = !this.showLegend;
    } else if (button['@type'] === 'TOGGLE_EXPAND_AND_COLLAPSE_ALL_GROUPS') {
      if (this.timelineGroupsDataSet) {
        let allGroupsCollapsed = true;
        this.timelineGroupsDataSet.forEach((currentGrp: any) => {
          if (currentGrp.showNested || currentGrp.showNested === undefined) {
            allGroupsCollapsed = false;
          }
        });

        this.timelineGroupsDataSet.forEach((currentGrp: any) => {
          currentGrp.showNested = allGroupsCollapsed;
          currentGrp.visible = true;
        });

        if (this.timeline) {
          this.timeline.setGroups(this.timelineGroupsDataSet);
        }
      }
    }
  }

  onFabButtonClick(button: DisguiseDto.TimelineFabButton) {
    if (button.action) {
      this.onFabButtonChildClick(button.action);
    }
  }

  onDialogToolbarButtonClicked(eventData: ToolbarButtonClickedEventData) {
    switch (eventData.button.action) {
      case 'DELETE':
        if (eventData.button.confirmationText) {
          this.confirmationDialogConfig = {
            title: 'Bestätigen',
            headerColor: 'primary',
            message: eventData.button.confirmationText,
            buttons: [{
              text: 'Bestätigen',
              title: 'Bestätigen',
              disabled: false,
              loading: false,
              autoFocus: true,
              onClick: () => {
                if (eventData.deleteFunctionRef) {
                  eventData.deleteFunctionRef();
                } else {
                  throw new Error('Delete Function undefined');
                }
                this.confirmationDialogConfig = null;
              }
            }, {
              text: 'Abbrechen',
              title: 'Abbrechen',
              disabled: false,
              loading: false,
              onClick: () => {
                this.confirmationDialogConfig = null;
              }
            }],
            onEsc: () => {
              this.confirmationDialogConfig = null;
            }
          };
        } else {
          if (eventData.deleteFunctionRef) {
            eventData.deleteFunctionRef();
          } else {
            throw new Error('Delete Function undefined');
          }
        }
        break;
      default:
        break;
    }
  }

  closeDialog() {
    if (this.dialog?.onAbort) {
      this.dialog.onAbort();
    }
    if (this.timeline) {
      this.timeline.setSelection([]);
    }
    this.dialog = null;
    this.showDialog = false;
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
  }

  resizeNorth() {
    Vue.nextTick(() => {
      const newNorthHeight = (this.$refs.northPanel || {}).clientHeight || 0;
      if (this.northHeight !== newNorthHeight) {
        this.northHeight = newNorthHeight;
        Vue.nextTick(() => {
          this.repositionFixedTableHeader();
        });
      }
    });
  }

  resizeSouth() {
    Vue.nextTick(() => {
      const newSouthHeight = (this.$refs.southPanel || {}).clientHeight || 0;
      if (this.southHeight !== newSouthHeight) {
        this.southHeight = newSouthHeight;
        Vue.nextTick(() => {
          this.repositionFixedTableHeader();
        });
      }
    });
  }

  closeSubMenu(eventPayload: SubmenuClosePayload) {
    if (eventPayload
        && eventPayload.closeData
        && eventPayload.closeData['@type'] !== undefined
        && eventPayload.closeData['@type'] === 'REOPEN_DIALOG') {
      const castedPayload = eventPayload.closeData as TimelineReopenDialogSubmenuData;
      if (castedPayload.dialog) {
        this.dialog = castedPayload.dialog;
        this.showDialog = true;
      }
    }
    this.subMenu = null;
  }

  setHolidays(newSettings: {
    holidays: Holidays,
    selected: ExtendedHolidays
  }) {
    this.holidays = newSettings.holidays;
    this.currentHolidaySelection = newSettings.selected;

    if (this.originalApiResponse !== undefined && !this.loading) {
      this.afterDataLoaded(this.originalApiResponse);
    } else {
      this.loadData();
    }
  }

  destroyed() {
    this.unregisterAllGlobalEventListeners();

    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
  }

  openSubNavi(response: DisguiseDto.RedirectDto) {
    this.closeDialog();
    const castedResponse = response as DisguiseDto.RedirectDto;
    if (castedResponse.actionType && castedResponse.actionType['@type'] === 'SubMenuRedirectActionType') {
      this.subMenu = {
        url: castedResponse.actionType.url || '',
        contextParameter: castedResponse.actionType.contextParameter,
        title: '',
        breadcrumbs: [],
      };
    }
  }

  private unregisterAllGlobalEventListeners() {
    if (this.registeredGlobalEventListenerNames) {
      for (const currentGlobalEventListenerName of this.registeredGlobalEventListenerNames) {
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.detachListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
      }
    }
  }

  private registerGlobalEventListener(currentGlobalEventListenerName: string) {
    GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.registerListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
    this.registeredGlobalEventListenerNames.push(currentGlobalEventListenerName);
  }

  private globalEventListenerTriggeredCb(eventData: any) {
    if (eventData) {
      const eventType = eventData['@type'];
      if (eventType) {
        switch (eventType) {
          case 'TimelineOpenSubmenuActionDto': {
            const castedEventData = eventData as DisguiseDto.TimelineOpenSubmenuActionDto;
            if (castedEventData.closeDialog) {
              this.showDialog = false;
            }
            let submenuCloseEventData: TimelineSubmenuData | undefined;
            if (castedEventData.reopenDialogAfterSubmenuClose) {
              const reopenDialogEvent: TimelineReopenDialogSubmenuData = {
                '@type': 'REOPEN_DIALOG',
                'dialog': this.dialog || undefined
              };
              submenuCloseEventData = reopenDialogEvent;
            }
            this.subMenu = {
              url: castedEventData.subNaviUrl || '',
              title: castedEventData.subNaviTitle || '',
              breadcrumbs: [],
              contextParameter: castedEventData.contextParameter,
              closeData: submenuCloseEventData
            };
            break;
          }
          case 'TimelineReloadActionDto': {
            const castedReloadAction = eventData as DisguiseDto.TimelineReloadActionDto;
            if (castedReloadAction.reloadFilterPanelOnly) {
              this.reloadFilterPanelsOnly();
            } else {
              this.loadData();
            }
            break;
          }
          default: {
            break;
          }
        }
      }
    }
  }

  private bindToReload() {
    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
    if (this.userRequestedReload) {
      this.userRequestedReloadSubscription = this.userRequestedReload.subscribe((reqId) => {
        if (this.timeline) { // ever loaded data
          if (this.reloadOnUserRequest && this.lastUserRequestedReloadReqId !== reqId) {
            this.lastUserRequestedReloadReqId = reqId;
            this.loadData();
          }
        }
      });
    }
  }

  private lookupFilterIndex(filter: DisguiseDto.TimelineFilterDto) {
    let filterIndex = -1;
    for (let currentFilterIndex = 0; currentFilterIndex < this.timelineFilters.length; currentFilterIndex++) {
      const currentFilter = this.timelineFilters[currentFilterIndex];
      if (currentFilter.filterId === filter?.filterId) {
        filterIndex = currentFilterIndex;
        break;
      }
    }
    return filterIndex;
  }

  private loadData(changeResponse?: DisguiseDto.TimelineModifyResponseDto, create?: boolean) {
    this.loading = true;

    let apiUrl = this.endpointUrl;
    if (this.timelineFilters) {
      apiUrl += '?' + URL_SERVICE_INSTANCE.serialize({filters: this.timelineFilters});
    }

    this.cancelToken.cancel();
    this.cancelToken = Axios.CancelToken.source();

    // Create a Timeline based on our settings
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.TimelineDto>(
        apiUrl,
        {cancelToken: this.cancelToken.token}
    ).then(
        (result: AxiosResponse<DisguiseDto.TimelineDto>) => {
          this.afterDataLoaded(result.data, changeResponse, create);
          Vue.nextTick(() => {
            this.applyVisInnerContentStyling();
            this.initialLoadCompleted = true;
          });
        }, (error) => {
          if (!error || !error.__CANCEL__) {
            this.$store.commit('showSnack', {
              message: 'Datenabruf fehlgeschlagen.',
              color: 'error'
            });
            this.loading = false;
            this.initialLoadCompleted = true;
          }
        });
  }

  /**
   * Note: In the current iteration, this function is used to style key-value pairs in
   * the vis-inner elements of the timeline. At the moment this is only used in the trp
   * rental calendar, but it might affect other timeline implementations
   */
  private applyVisInnerContentStyling() {
    const elements = document.querySelectorAll('.vis-inner');
    elements.forEach((el) => {
      for (const childNode of (el.childNodes || [])) {
        if (childNode && childNode.nodeName === '#text' && childNode.nodeValue) {
          const stylableTargetMatch = childNode.nodeValue.split(':');
          if (stylableTargetMatch && stylableTargetMatch.length === 2) {
            const key = stylableTargetMatch[0];
            const replaceVal = `<strong>${key}:</strong>`.padEnd(40);
            el.innerHTML = el.innerHTML.replace(`${key}:`, replaceVal);
          }
        }
      }
    });
  }

  private onEmptyAreaClick(action: DisguiseDto.ITimelineItemActionUnion, event: any) {
    if (action['@type'] === 'DIALOG') {
      const content = action.content;
      if (content !== undefined) {
        const snappedStartDate = this.snapDate(
            event.time,
            this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.snap?.roundToFull
        );
        const snappedStart =
            moment(snappedStartDate).format(DatePatterns.MOMENT_ISO_8601_PATTERN);
        const snappedStartWithoutTime =
            moment(snappedStartDate).format(DatePatterns.LOCAL_DATE_PATTERN);
        let endDate;
        let endDateWithoutTime;
        if (this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.endDiff) {
          endDate = moment(snappedStartDate).add(
              this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.endDiff?.amount,
              this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.endDiff?.unit
          ).format(DatePatterns.MOMENT_ISO_8601_PATTERN);
          endDateWithoutTime = moment(snappedStartDate).add(
              this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.endDiff?.amount,
              this.originalApiResponse?.actions?.clickIntoEmptyItemArea?.endDiff?.unit
          ).format(DatePatterns.LOCAL_DATE_PATTERN);
        } else {
          endDate = moment(snappedStartDate)
              .format(DatePatterns.MOMENT_ISO_8601_PATTERN);
          endDateWithoutTime = moment(snappedStartDate)
              .format(DatePatterns.LOCAL_DATE_PATTERN);
        }
        const overwrittenFields:
            { [fieldName: string]: DisguiseDto.FTFieldDto } = {};

        if (action.startDateFieldPath !== undefined) {
          set(overwrittenFields, action.startDateFieldPath, {
            type: 'FTFieldDto',
            value: snappedStart
          });
        }

        if (action.startDateWithoutTimeFieldPath !== undefined) {
          set(overwrittenFields, action.startDateWithoutTimeFieldPath, {
            type: 'FTFieldDto',
            value: snappedStartWithoutTime
          });
        }

        if (action.endDateFieldPath !== undefined) {
          set(overwrittenFields, action.endDateFieldPath, {
            type: 'FTFieldDto',
            value: endDate
          });
        }

        if (action.endDateWithoutTimeFieldPath !== undefined) {
          set(overwrittenFields, action.endDateWithoutTimeFieldPath, {
            type: 'FTFieldDto',
            value: endDateWithoutTime
          });
        }

        const groupDropTemplates = action.groupTemplates;
        if (event.group && groupDropTemplates && this.timeline) {
          for (const currentGroup of this.timelineGroups) {
            if (currentGroup.id === event.group) {
              let groupContent = currentGroup.content || '';
              const groupContentWithoutHtmlTags = groupContent.replace(/<[^>]*>/g, '');

              for (const currentGroupConfig of groupDropTemplates || []) {
                if (currentGroupConfig.groupContentRegex) {
                  const regExp =
                      new RegExp(currentGroupConfig.groupContentRegex);
                  const regexResult =
                      regExp.exec(groupContentWithoutHtmlTags) || [];
                  groupContent = regexResult[0] || '';
                }
                if (currentGroupConfig.groupIdRegex) {
                  const regExp =
                      new RegExp(currentGroupConfig.groupIdRegex);
                  const regexResult =
                      regExp.exec(currentGroup.id || '') || [];
                  groupContent = regexResult[currentGroupConfig.groupToUse || 0] || '';
                }

                overwrittenFields[currentGroupConfig.fieldName] = JSON.parse(
                    JSON.stringify(currentGroupConfig.value)
                        .replace('{groupId}', event.group)
                        .replace('{groupContent}', groupContent)
                );
              }

              break;
            }
          }
        }

        this.dialog = {
          key: this.dialogKey++,
          dialogTitle: action.dialogTitle || '',
          create: true,
          tabRenderKeyCount: 0,
          content,
          overwrittenFields,
          maxWidth: action.maxWidth || ''
        };
        this.openDialog();
      }
    }
  }

  private openDialog() {
    this.showDialog = true;
    this.originalDocumentScrollXOffset =
        DOCUMENT_SCROLL_SERVICE_INSTANCE.readCurrentDocumentScrollXPosition();
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(0);
  }

  /**
   * Snaps the date
   * if (condition) -> round time
   */
  private snapDate(date: Date, roundToFull: DisguiseDto.TimelineSnapRoundSettingEnum | undefined) {
    let snapResult = date;
    if (roundToFull === 'hour') {
      const snapMoment = moment(date);
      if (snapMoment.get('minutes') > 30) {
        snapResult = snapMoment.set({
          minutes: 60,
          seconds: 0,
          milliseconds: 0
        }).toDate();
      } else {
        snapResult = snapMoment.set({
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        }).toDate();
      }
    }
    return snapResult;
  }

  /**
   * Returns the time axis HTML Element
   */
  private getFloatingTableHeader(): HTMLElement | null {
    if (!this.floatingTableHeader) {
      let result: HTMLElement | null = null;
      const elementRaw = this.$el.querySelector('.vis-panel.vis-top');
      if (elementRaw && elementRaw instanceof HTMLElement) {
        result = elementRaw;
      }
      this.floatingTableHeader = result;
    }
    return this.floatingTableHeader;
  }

  /**
   * Returns the time axis HTML Element
   */
  private getFloatingGroupBar(): HTMLElement | null {
    if (!this.floatingGroupBar) {
      let result: HTMLElement | null = null;
      const elementRaw = this.$el.querySelector('.vis-panel.vis-left .vis-content');
      if (elementRaw && elementRaw instanceof HTMLElement) {
        result = elementRaw;
      }
      this.floatingGroupBar = result;
    }
    return this.floatingGroupBar;
  }

  /**
   * updates the position of the floating time axis bar
   */
  private repositionFixedTableHeader() {
    const timeAxis = this.getFloatingTableHeader();
    const groupBar = this.getFloatingGroupBar();
    if (timeAxis && groupBar) {
      const groupBarWidth = groupBar.getBoundingClientRect().width || 0;
      this.$refs.timeline.style.marginLeft = groupBarWidth + 'px';

      const timeAxisTargetY = this.$vuetify.application.top + this.$refs.timeline.offsetTop;
      const timeAxisTargetX = this.$vuetify.application.left + groupBarWidth - window.scrollX + 1;
      timeAxis.style.transform = 'translate(' + timeAxisTargetX + 'px, ' + timeAxisTargetY + 'px)';

      const groupBarTargetX = this.$vuetify.application.left;
      let groupBarTargetY = this.$vuetify.application.top + this.$refs.timeline.offsetTop + 34 - window.scrollY;
      if (this.originalApiResponse && this.originalApiResponse.settings && this.originalApiResponse.settings.showMajorLabels) {
        groupBarTargetY += 25;
      }

      groupBar.style.transform = 'translate(' + groupBarTargetX + 'px, ' + groupBarTargetY + 'px)';
    }
  }

  private highlightAndScrollToLastUpdatedTimelineItem() {
    const updatedElements: Array<{
      time: string,
      item: HTMLElement
    }> = [];
    const updatedClass = 'ametras-timeline__item--highlighted';
    const timestampUpdatedClassPrefix = 'ametras-timeline__item--highlighted--';
    const updatedEls = document.getElementsByClassName(updatedClass);
    for (const updatedEl of updatedEls) {
      for (const className of updatedEl.classList.values()) {
        const index = className.indexOf(timestampUpdatedClassPrefix);
        if (index === 0) {
          const updatedTimestamp = className.substr(timestampUpdatedClassPrefix.length);
          updatedElements.push({
            time: updatedTimestamp,
            item: updatedEl as HTMLElement
          });
          break;
        }
      }
    }
    if (updatedElements && updatedElements.length) {
      const orderedUpdatedEls = orderBy(updatedElements, ['time'], ['desc']);
      const elementRect = orderedUpdatedEls[0].item.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const absoluteElementLeft = elementRect.left + window.pageXOffset;
      const middleY = absoluteElementTop - (window.innerHeight / 2);
      const middleX = absoluteElementLeft - (window.innerWidth / 2);
      window.scrollTo(middleX, middleY);
    }
  }

  /**
   * Scrolls to the first day of this week
   */
  private scrollToFirstDayOfCurrentWeek() {
    const today = moment();
    const firstDayInCurrentWeek = today.startOf('week');
    const numberOfFirstDayInCurrentWeek = firstDayInCurrentWeek.date();
    const nameOfMonthOfFirstDayInCurrentWeek = firstDayInCurrentWeek.format('MMMM').toLowerCase();
    let elementToScrollTo = document.getElementsByClassName(`vis-${nameOfMonthOfFirstDayInCurrentWeek} vis-day${numberOfFirstDayInCurrentWeek}`)[0];
    if (!elementToScrollTo) {
      elementToScrollTo = document.getElementsByClassName('vis-today')[0];
    }
    if (elementToScrollTo) {
      const todayElXOffset = elementToScrollTo.getBoundingClientRect().x;
      const pageXOffset = window.pageXOffset;
      const groupWrapperEl = document.getElementsByClassName('vis-labelset')[0];
      const groupWrapperElWidth = groupWrapperEl.getBoundingClientRect().width;
      const borderOffset = 1;
      const naviOffset = this.$store.state.navigation.show ? this.$vuetify.application.left : 0;
      window.scrollTo(todayElXOffset + pageXOffset - groupWrapperElWidth + borderOffset - naviOffset, 0);
    }
  }

  /**
   * Scrolls to the first day of search result
   */
  private scrollToStartDate() {
    window.scrollTo(0, window.pageYOffset);
  }

  /**
   * Formattes the minor labels
   * 1. if there is any custom format provided, we'll take this
   * 2. if the indexedHolidaysForViewRange contains the day, we'll add the holiday name to the next line
   * @param date
   * @param scale
   * @param step
   * @param result
   * @private
   */
  private formatMinorLabels(date: Date, scale: string, step: number, result: DisguiseDto.TimelineDto) {
    const defaultFormat: {
      minorLabels: { [key: string]: string },
      majorLabels: { [key: string]: string }
    } = {
      minorLabels: {
        millisecond: 'SSS',
        second: 's',
        minute: 'HH:mm',
        hour: 'HH:mm',
        weekday: 'ddd D',
        day: 'D',
        week: 'w',
        month: 'MMM',
        year: 'YYYY'
      },
      majorLabels: {
        millisecond: 'HH:mm:ss',
        second: 'D MMMM HH:mm',
        minute: 'ddd D MMMM',
        hour: 'ddd D MMMM',
        weekday: 'MMMM YYYY',
        day: 'MMMM YYYY',
        week: 'MMMM YYYY',
        month: 'YYYY',
        year: ''
      }
    };

    let format = result
    && result
    && result.settings
    && result.settings.format
    && result.settings.format.minorLabels
    && (result.settings.format.minorLabels as any)[scale || '']
        ? (result.settings.format.minorLabels as any)[scale || '']
        : null;
    if (!format) {
      format = defaultFormat.minorLabels[scale || ''];
    }
    // noinspection FallThroughInSwitchStatementJS
    switch (scale) {
      case 'week':
        // Don't draw the minor label if this date is the first day of a month AND if it's NOT the start of the week.
        // The 'date' variable may actually be the 'next' step when called from TimeAxis' _repaintLabels.
        if (moment(date).date() === 1 && moment(date).weekday() !== 0) {
          return '';
        }
      default: // eslint-disable-line no-fallthrough
        let formatResult = (format && format.length > 0) ? moment(date).format(format) : '';
        if (scale === 'day' && this.indexedHolidaysForViewRange) {
          const holidayName = this.indexedHolidaysForViewRange[moment(date).format('YYYY-MM-DD')];
          if (holidayName) {
            formatResult += '<br><span title="' + holidayName + '">' + holidayName + '</span>';
          }
        }
        return formatResult;
    }
  }

  /**
   * Formattes the major labels
   * 1. if there is any custom format provided, we'll take this
   * 2. if the indexedHolidaysForViewRange contains the day, we'll add the holiday name to the next line
   * @param date
   * @param scale
   * @param step
   * @param result
   * @private
   */
  private formatMajorLabels(date: Date, scale: string, step: number, result: DisguiseDto.TimelineDto) {
    const defaultFormat: {
      minorLabels: { [key: string]: string },
      majorLabels: { [key: string]: string }
    } = {
      minorLabels: {
        millisecond: 'SSS',
        second: 's',
        minute: 'HH:mm',
        hour: 'HH:mm',
        weekday: 'ddd D',
        day: 'D',
        week: 'w',
        month: 'MMM',
        year: 'YYYY'
      },
      majorLabels: {
        millisecond: 'HH:mm:ss',
        second: 'D MMMM HH:mm',
        minute: 'ddd D MMMM',
        hour: 'ddd D MMMM',
        weekday: 'MMMM YYYY',
        day: 'MMMM YYYY',
        week: 'MMMM YYYY',
        month: 'YYYY',
        year: ''
      }
    };

    let format = result
    && result
    && result.settings
    && result.settings.format
    && result.settings.format.majorLabels
    && (result.settings.format.majorLabels as any)[scale || '']
        ? (result.settings.format.majorLabels as any)[scale || '']
        : null;
    if (!format) {
      format = defaultFormat.majorLabels[scale || ''];
    }
    // noinspection FallThroughInSwitchStatementJS
    switch (scale) {
      case 'week':
        // Don't draw the minor label if this date is the first day of a month AND if it's NOT the start of the week.
        // The 'date' variable may actually be the 'next' step when called from TimeAxis' _repaintLabels.
        if (moment(date).date() === 1 && moment(date).weekday() !== 0) {
          return '';
        }
      default: // eslint-disable-line no-fallthrough
        let formatResult = (format && format.length > 0) ? moment(date).format(format) : '';
        if (scale === 'hour' && this.indexedHolidaysForViewRange) {
          const holidayName = this.indexedHolidaysForViewRange[moment(date).format('YYYY-MM-DD')];
          if (holidayName) {
            formatResult += ' / <span title="' + holidayName + '">' + holidayName + '</span>';
          }
        }
        return formatResult;
    }
  }

  private initializeFeatures(timelineFeatureConfig: DisguiseDto.ITimelineFeatureConfigUnion[]) {
    for (const currentFeatureConfig of timelineFeatureConfig || []) {
      if (currentFeatureConfig['@type'] === 'TimelineMechanicOnlineStatusFeatureConfig') {
        this.initializedFeatures.push(new MechanicOnlineStatusFeature().initialize(
            this.$refs.timeline,
            currentFeatureConfig,
            () => {
              this.repositionFixedTableHeader();
            }
        ));
      }
      if (currentFeatureConfig['@type'] === 'TimelineRestWorkingHoursFeatureConfigDto') {
        this.initializedFeatures.push(new MechanicRestWorkingHoursFeature().initialize(
            this.$refs.timeline,
            currentFeatureConfig,
            () => {
              this.repositionFixedTableHeader();
            }
        ));
      }
    }
  }

  private destroyFeatures() {
    for (const currentInitializedFeature of this.initializedFeatures || []) {
      currentInitializedFeature.destroy();
    }
  }

  private afterDataLoaded(
      result: DisguiseDto.TimelineDto,
      changeResponse?: DisguiseDto.TimelineModifyResponseDto,
      create?: boolean
  ) {
    // 1. unregister all existing event listeners
    this.unregisterAllGlobalEventListeners();
    const eventListeners = result.globalEventListeners;
    if (eventListeners) {
      for (const currentGlobalEventListenerName of eventListeners) {
        // 2. register all
        this.registerGlobalEventListener(currentGlobalEventListenerName);
      }
    }
    this.destroyFeatures();

    if (result.stylingVariablesSettings) {
      const darkColors: { [cssVarName: string]: string } = {};
      const lightColors: { [cssVarName: string]: string } = {};
      const globalStylingVariables: { [cssVarName: string]: string } = {};
      for (const currentColorKey of Object.keys(result.stylingVariablesSettings.darkThemeStylingVariables || {})) {
        darkColors[('--' + currentColorKey)] = (result.stylingVariablesSettings.darkThemeStylingVariables || {})[currentColorKey];
      }
      for (const currentColorKey of Object.keys(result.stylingVariablesSettings.lightThemeStylingVariables || {})) {
        lightColors[('--' + currentColorKey)] = (result.stylingVariablesSettings.lightThemeStylingVariables || {})[currentColorKey];
      }
      for (const currentStylingVarKey of Object.keys(result.stylingVariablesSettings.globalStylingVariables || {})) {
        globalStylingVariables[('--' + currentStylingVarKey)] = (result.stylingVariablesSettings.globalStylingVariables || {})[currentStylingVarKey];
      }

      this.darkColors = darkColors;
      this.lightColors = lightColors;
      this.globalStylingVariables = globalStylingVariables;
    }
    this.submitFiltersOnUserRequest = (result.advancedSettings
        && result.advancedSettings.submitFiltersOnUserRequest) || false;
    if (!this.timelineOptions) {
      // initial setup
      // @ts-ignore
      this.timelineOptions = {
        ...result.settings,
        xss: {
          disabled: false,
          filterOptions: {
            whiteList: {
              span: ['onlinestatus', 'class', 'title'],
              br: [],
              div: ['class', 'style', 'restworkinghours'],
              svg: ['style', 'viewbox'],
              path: ['fill', 'd']
            }
          }
        },
        rollingMode: {
          // empty object as a fix for missing onInitialDrawComplete event
          // https://github.com/visjs/vis-timeline/issues/876
        },
        format: {
          minorLabels: (date: Date, scale: string, step: number) => {
            return this.formatMinorLabels(date, scale, step, result);
          },
          majorLabels: (date: Date, scale: string, step: number) => {
            return this.formatMajorLabels(date, scale, step, result);
          }
        },
        moment: (inp?: MomentInput, format?: MomentFormatSpecification, strict?: boolean) => {
          // use our own moment instance to format dates
          return this.$moment(inp, format, strict);
        },
        onInitialDrawComplete: () => {
          this.repositionFixedTableHeader();
          Vue.nextTick(() => {
            this.scrollToFirstDayOfCurrentWeek();
          });
          if (result.timelineFeatureConfig) {
            this.initializeFeatures(result.timelineFeatureConfig);
          }
        },
        snap: (date) => {
          return this.snapDate(date, result.actions?.moveItemActionSettings?.snap?.roundToFull);
        },
        onUpdate: (item: TimelineItem, callback: (item: TimelineItem | null) => void) => {
          callback(item);
        },
        onMove: (item: TimelineItem, callback: (item: TimelineItem | null) => void) => {
          const startDate = moment(item.start).format(DatePatterns.MOMENT_ISO_8601_PATTERN);
          const startDateWithoutTime = moment(item.start).format(DatePatterns.LOCAL_DATE_PATTERN);

          let endDate;
          let endDateWithoutTime;
          const endMoment = moment(item.end);
          if (endMoment.get('hours') === 0) {
            endDate = endMoment.subtract(1, 'second')
                .format(DatePatterns.MOMENT_ISO_8601_PATTERN);
            endDateWithoutTime = endMoment.subtract(1, 'second')
                .format(DatePatterns.LOCAL_DATE_PATTERN);
          } else {
            endDate = endMoment.format(DatePatterns.MOMENT_ISO_8601_PATTERN);
            endDateWithoutTime = endMoment.format(DatePatterns.LOCAL_DATE_PATTERN);
          }

          // clicked on an item

          // find original item
          let foundItem;
          if (!(this.originalApiResponse || {}).exactIdMapping) {
            for (const currentItem of this.originalApiResponse?.items || []) {
              if (currentItem.id.indexOf(String(item.id)) === 0) {
                foundItem = currentItem;
                break;
              }
            }
          } else {
            for (const currentItem of this.originalApiResponse?.items || []) {
              if (currentItem.id === String(item.id)) {
                foundItem = currentItem;
                break;
              }
            }
          }

          if (foundItem && foundItem.moveItemAction) {
            if (foundItem.moveItemAction?.action) {
              if (foundItem.moveItemAction.action['@type'] === 'DIALOG') {
                const content = foundItem.moveItemAction.action.content;
                if (content !== undefined) {
                  const overwrittenFields:
                      { [fieldName: string]: DisguiseDto.FTFieldDto } = {};

                  if (foundItem.moveItemAction.startDateFieldPath !== undefined) {
                    set(overwrittenFields, foundItem.moveItemAction.startDateFieldPath, {
                      type: 'FTFieldDto',
                      value: startDate
                    });
                  }
                  if (foundItem.moveItemAction.startDateWithoutTimeFieldPath !== undefined) {
                    set(overwrittenFields, foundItem.moveItemAction.startDateWithoutTimeFieldPath, {
                      type: 'FTFieldDto',
                      value: startDateWithoutTime
                    });
                  }

                  if (foundItem.moveItemAction.endDateFieldPath !== undefined) {
                    set(overwrittenFields, foundItem.moveItemAction.endDateFieldPath, {
                      type: 'FTFieldDto',
                      value: endDate
                    });
                  }

                  if (foundItem.moveItemAction.endDateWithoutTimeFieldPath !== undefined) {
                    set(overwrittenFields, foundItem.moveItemAction.endDateWithoutTimeFieldPath, {
                      type: 'FTFieldDto',
                      value: endDateWithoutTime
                    });
                  }

                  const groupDropTemplates = foundItem.moveItemAction.action.groupTemplates;
                  if (item.group && groupDropTemplates && this.timeline) {
                    for (const currentGroup of this.timelineGroups) {
                      if (currentGroup.id === item.group) {
                        let groupContent = currentGroup.content || '';
                        const groupContentWithoutHtmlTags = groupContent.replace(/<[^>]*>/g, '');

                        for (const currentGroupConfig of groupDropTemplates || []) {
                          if (currentGroupConfig.groupContentRegex) {
                            const regExp =
                                new RegExp(currentGroupConfig.groupContentRegex);
                            const regexResult =
                                regExp.exec(groupContentWithoutHtmlTags) || [];
                            groupContent = regexResult[0] || '';
                          }
                          if (currentGroupConfig.groupIdRegex) {
                            const regExp =
                                new RegExp(currentGroupConfig.groupIdRegex);
                            const regexResult =
                                regExp.exec(currentGroup.id || '') || [];
                            groupContent = regexResult[currentGroupConfig.groupToUse || 0] || '';
                          }

                          overwrittenFields[currentGroupConfig.fieldName] = JSON.parse(
                              JSON.stringify(currentGroupConfig.value)
                                  .replace('{groupId}', item.group)
                                  .replace('{groupContent}', groupContent)
                          );
                        }

                        break;
                      }
                    }
                  }

                  this.dialog = {
                    key: this.dialogKey++,
                    dialogTitle: foundItem.moveItemAction.action.dialogTitle || '',
                    create: false,
                    tabRenderKeyCount: 0,
                    content,
                    overwrittenFields,
                    editKey: foundItem.moveItemAction.action.customEditKey || {
                      [foundItem.moveItemAction.idFieldName || 'id']: String(item.id)
                    },
                    maxWidth: foundItem.moveItemAction.action.maxWidth || '',
                    onApply: () => {
                      // apply changes
                      callback(item);
                    },
                    onAbort: () => {
                      // revert changes
                      callback(null);
                    }
                  };
                  this.openDialog();
                }
              }
            }

          }
        }
      };
    }

    this.timelineGroups = result.groups || [];

    this.timelineGroupsDataSet = new DataSet(result.groups || []);

    const holidayBackgroundItems: any[] = [];
    if (result && result && result.settings) {
      const start = result.settings.start;
      const end = result.settings.end;
      if (this.holidays) {
        const rangeOfYears = (startYear: number, endYear: number) => {
          return Array<number>(endYear - startYear + 1)
              .fill(startYear)
              .map((year, index) => year + index);
        };
        const years = rangeOfYears(moment(start).year(), moment(end).year());
        const indexedHolidays: { [isoFormattedDate: string]: string } = {};
        for (const currentYear of years) {
          const holidaysForCurrentYear = this.holidays.getHolidays(currentYear);
          for (let holidayIdx = 0; holidayIdx < holidaysForCurrentYear.length; holidayIdx++) {
            const holiday = holidaysForCurrentYear[holidayIdx];
            if (this.EXCLUDED_HOLIDAY_TYPES.indexOf(holiday.type) < 0) {
              const parsedHolidayDate = moment(holiday.date, 'YYYY-MM-DD HH:mm:ss');
              const holidayStart = parsedHolidayDate.startOf('day').toDate();
              const holidayEnd = parsedHolidayDate.endOf('day').toDate();
              indexedHolidays[parsedHolidayDate.format('YYYY-MM-DD')] = holiday.name;

              const contentEl = document.createElement('span');
              contentEl.title = holiday.name;

              holidayBackgroundItems.push({
                start: holidayStart,
                end: holidayEnd,
                id: currentYear + holiday.date + holidayIdx,
                type: 'background',
                content: contentEl,
                title: holiday.name,
                className: 'ametras-timeline__background ametras-timeline__background--holiday'
              });
            }
          }
        }
        this.indexedHolidaysForViewRange = indexedHolidays;
      } else {
        this.indexedHolidaysForViewRange = {};
      }
    }

    const items = new DataSet<any>(result.items || []);
    if (holidayBackgroundItems) {
      for (const currentHolidayItem of holidayBackgroundItems) {
        if (items.get(currentHolidayItem.id) === null) {
          items.add(currentHolidayItem);
        }
      }
    }
    this.originalApiResponse = result;

    if (changeResponse?.changedItemId !== undefined) {
      // get items where id starts with changeResponse?.changedItemId
      for (const item of items.get()) {
        if (item.id.indexOf(changeResponse.changedItemId) === 0) {
          items.update({
            ...item,
            className: item.className + ' ametras-timeline__item--highlighted' + ' ametras-timeline__item--highlighted--' + moment.now() + (create ? ' ametras-timeline__item--created' : '')
          });

          if (changeResponse?.openAfterModified) {
            this.openDialogAfterModified(item);
          }
        }
      }
    }

    if (changeResponse?.changedItemReferenceKey !== undefined) {
      // get items where id starts with changeResponse?.changedItemId
      for (const item of items.get()) {
        if (isEqual(item.referenceKey, changeResponse.changedItemReferenceKey)) {
          items.update({
            ...item,
            className: item.className + ' ametras-timeline__item--highlighted' + ' ametras-timeline__item--highlighted--' + moment.now() + (create ? ' ametras-timeline__item--created' : '')
          });
          if (changeResponse?.openAfterModified) {
            this.openDialogAfterModified(item);
          }
        }
      }
    }

    if (!this.timeline) {
      if (this.timelineOptions) {
        this.timeline = new Timeline(
            this.$refs.timeline,
            items,
            this.timelineGroupsDataSet,
            this.timelineOptions
        );

        this.timeline.on('changed', () => {
          this.repositionFixedTableHeader();
          this.highlightAndScrollToLastUpdatedTimelineItem();
          this.applyVisInnerContentStyling();
        });

        this.timeline.on('drop', (event) => {
          if (event.time) {
            event.event.dataTransfer.items[0].getAsString((dataTransferItem: string) => {
              const dataTransfer = JSON.parse(dataTransferItem);

              const droppedMoment = moment(event.time);
              const endDate = droppedMoment.startOf('day').add(17, 'hours')
                  .format(DatePatterns.MOMENT_ISO_8601_PATTERN);
              const startDate = droppedMoment.startOf('day').add(7, 'hours')
                  .format(DatePatterns.MOMENT_ISO_8601_PATTERN);
              const endDateWithoutTime = droppedMoment.format(DatePatterns.LOCAL_DATE_PATTERN);
              const startDateWithoutTime = droppedMoment.format(DatePatterns.LOCAL_DATE_PATTERN);

              // clicked on an item
              const actions = result.actions;
              if (actions?.dropIntoItemArea) {
                if (actions.dropIntoItemArea['@type'] === 'DIALOG') {
                  const content = actions.dropIntoItemArea.content;
                  if (content !== undefined) {
                    const overwrittenFields:
                        { [fieldName: string]: DisguiseDto.FTFieldDto } = {};

                    for (const currentDataTransferKey of Object.keys(dataTransfer)) {
                      const currentDataTransferValue =
                          dataTransfer[currentDataTransferKey];
                      overwrittenFields[currentDataTransferKey] = {
                        type: 'FTFieldDto',
                        value: currentDataTransferValue
                      };
                    }

                    if (actions.dropIntoItemArea.startDateFieldPath !== undefined) {
                      set(overwrittenFields, actions.dropIntoItemArea.startDateFieldPath, {
                        type: 'FTFieldDto',
                        value: startDate
                      });
                    }
                    if (actions.dropIntoItemArea.startDateWithoutTimeFieldPath !== undefined) {
                      set(overwrittenFields, actions.dropIntoItemArea.startDateWithoutTimeFieldPath, {
                        type: 'FTFieldDto',
                        value: startDateWithoutTime
                      });
                    }

                    if (actions.dropIntoItemArea.endDateFieldPath !== undefined) {
                      set(overwrittenFields, actions.dropIntoItemArea.endDateFieldPath, {
                        type: 'FTFieldDto',
                        value: endDate
                      });
                    }

                    if (actions.dropIntoItemArea.endDateWithoutTimeFieldPath !== undefined) {
                      set(overwrittenFields, actions.dropIntoItemArea.endDateWithoutTimeFieldPath, {
                        type: 'FTFieldDto',
                        value: endDateWithoutTime
                      });
                    }

                    const groupDropTemplates = actions.dropIntoItemArea.groupTemplates;
                    if (event.group && groupDropTemplates && this.timeline) {
                      for (const currentGroup of this.timelineGroups) {
                        if (currentGroup.id === event.group) {
                          let groupContent = currentGroup.content || '';
                          const groupContentWithoutHtmlTags = groupContent.replace(/<[^>]*>/g, '');

                          for (const currentGroupConfig of groupDropTemplates || []) {
                            if (currentGroupConfig.groupContentRegex) {
                              const regExp =
                                  new RegExp(currentGroupConfig.groupContentRegex);
                              const regexResult =
                                  regExp.exec(groupContentWithoutHtmlTags) || [];
                              groupContent = regexResult[currentGroupConfig.groupToUse || 0] || '';
                            }
                            if (currentGroupConfig.groupIdRegex) {
                              const regExp =
                                  new RegExp(currentGroupConfig.groupIdRegex);
                              const regexResult =
                                  regExp.exec(currentGroup.id || '') || [];
                              groupContent = regexResult[currentGroupConfig.groupToUse || 0] || '';
                            }

                            overwrittenFields[currentGroupConfig.fieldName] = JSON.parse(
                                JSON.stringify(currentGroupConfig.value)
                                    .replace('{groupId}', event.group)
                                    .replace('{groupContent}', groupContent)
                            );
                          }

                          break;
                        }
                      }
                    }

                    this.dialog = {
                      key: this.dialogKey++,
                      dialogTitle: actions.dropIntoItemArea.dialogTitle || '',
                      create: true,
                      tabRenderKeyCount: 0,
                      content,
                      overwrittenFields,
                      maxWidth: actions.dropIntoItemArea.maxWidth || ''
                    };
                    this.openDialog();
                  }
                }
              }
            });
          }
        });

        this.timeline.on('select', (event: any) => {
          if (event.items.length) {
            const itemId = event.items[0];
            // clicked on an item

            // find original item
            let foundItem;
            if (!(this.originalApiResponse || {}).exactIdMapping) {
              for (const currentItem of this.originalApiResponse?.items || []) {
                if (currentItem.id.indexOf(itemId) === 0) {
                  foundItem = currentItem;
                  break;
                }
              }
            } else {
              for (const currentItem of this.originalApiResponse?.items || []) {
                if (currentItem.id === itemId) {
                  foundItem = currentItem;
                  break;
                }
              }
            }

            if (foundItem && foundItem.selectItemAction) {
              if (foundItem.selectItemAction['@type'] === 'DIALOG') {
                const content = foundItem.selectItemAction.content;
                if (content !== undefined) {
                  this.dialog = {
                    key: this.dialogKey++,
                    dialogTitle: foundItem.selectItemAction.dialogTitle || '',
                    create: false,
                    tabRenderKeyCount: 0,
                    content,
                    editKey: foundItem.selectItemAction.customEditKey || {
                      [foundItem.selectItemAction.idFieldName || 'id']: String(itemId)
                    },
                    maxWidth: foundItem.selectItemAction.maxWidth || '',
                    fullscreen: foundItem.selectItemAction.fullscreen
                  };
                  this.openDialog();
                }
              } else if (foundItem.selectItemAction['@type'] === 'SUBMENU') {
                this.subMenu = {
                  url: foundItem.selectItemAction.url || '',
                  contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(foundItem.selectItemAction.params),
                  title: '',
                  breadcrumbs: []
                };
              }
            }
          }
        });

        this.timeline.on('click', (event: any) => {
          this.showContextMenu = false;
          const itemPresent = event.item !== undefined && event.item !== null;
          const clickedWithinItemArea = event.event.target.classList.contains('vis-group');
          const dialogPresent = this.dialog !== null;
          const clickedOnAGroupLabel = event.what === 'group-label';
          const clickedOnABackgroundItem = event.what === 'background';

          if (clickedOnAGroupLabel) {
            let foundGroup;
            for (const currentGroup of this.originalApiResponse?.groups || []) {
              if (currentGroup.id === event.group) {
                foundGroup = currentGroup;
                break;
              }
            }
            if (foundGroup) {
              if ((foundGroup.groupClickedAction || {})['@type'] === 'SUBMENU') {
                this.subMenu = {
                  url: (foundGroup.groupClickedAction || {}).url || '',
                  contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(
                      (foundGroup.groupClickedAction || {}).params
                  ),
                  title: '',
                  breadcrumbs: []
                };
              }
            }
          }

          if (!dialogPresent && !itemPresent && !clickedOnAGroupLabel && (clickedWithinItemArea || clickedOnABackgroundItem)) {
            // clicked within empty item area

            const actions = this.originalApiResponse?.actions;
            if (actions?.clickIntoEmptyItemArea?.action) {
              if (actions.clickIntoEmptyItemArea.action['@type'] === 'CONTEXT_MENU') {
                const castedAction =
                    actions.clickIntoEmptyItemArea.action as DisguiseDto.TimelineItemContextMenu;
                this.contextMenu.positionX = event.event.clientX;
                this.contextMenu.positionY = event.event.clientY;
                this.contextMenu.items = castedAction.items || [];
                this.contextMenu.originalEvent = event;
                this.$nextTick(() => {
                  this.showContextMenu = true;
                });
              } else {
                this.onEmptyAreaClick(actions.clickIntoEmptyItemArea.action, event);
              }
            }
          }
        });
      }

      this.filterConfiguration = result.filter || [];
      const filterInputConfiguration: DisguiseDto.TimelineFilterDto[] = [];
      for (const currentFilter of result.filter || []) {
        filterInputConfiguration.push({
          filterId: currentFilter.filterId,
          value: currentFilter.defaultValue || ''
        });
      }
      this.timelineFilters = filterInputConfiguration;
      if (result.panels) {
        this.panels = result.panels;
      }
      if ((result.panels || {}).north !== undefined) {
        Vue.nextTick(() => {
          const resizeSensor = new ResizeSensor(this.$refs.northPanel, () => {
            this.resizeNorth();
            this.resizeSouth();
          });
        });
      }
      // @ts-ignore
      this.lastStartDate = this.timelineOptions.start;
    } else {
      this.timeline.setData({
        items,
        groups: this.timelineGroups
      });

      if (result.settings) {
        // @ts-ignore
        this.timelineOptions = {
          ...this.timelineOptions,
          ...result.settings,
          format: {
            minorLabels: (date: Date, scale: string, step: number) => {
              return this.formatMinorLabels(date, scale, step, result);
            },
            majorLabels: (date: Date, scale: string, step: number) => {
              return this.formatMajorLabels(date, scale, step, result);
            }
          },
        };
        // @ts-ignore
        this.timeline?.setOptions(this.timelineOptions);

        Vue.nextTick(() => {
          this.destroyFeatures();
          if (result.timelineFeatureConfig) {
            this.initializeFeatures(result.timelineFeatureConfig);
          }
        });
      }
      this.resizeNorth();
      this.resizeSouth();

      if (this.lastStartDate !== this.timelineOptions?.start) {
        this.scrollToStartDate();
        this.lastStartDate = this.timelineOptions?.start;
      }
    }

    this.fabButtons = result.fabButtons || [];
    this.timelineLocations = result.locations || [];

    Vue.nextTick(() => {
      this.loading = false;
    });
  }

  private openDialogAfterModified(item: any) {
    const itemId = item;
    const content = item.selectItemAction.content;
    if (content !== undefined) {
      this.dialog = {
        key: this.dialogKey++,
        dialogTitle: item.selectItemAction.dialogTitle || '',
        create: false,
        tabRenderKeyCount: 0,
        content,
        editKey: item.selectItemAction.customEditKey || {
          [item.selectItemAction.idFieldName || 'id']: String(itemId)
        },
        maxWidth: item.selectItemAction.maxWidth || '',
        fullscreen: item.selectItemAction.fullscreen
      };
      this.openDialog();
    }
  }

  private reloadFilterPanelsOnly() {
    this.loading = true;

    let apiUrl = this.endpointUrl;
    if (this.timelineFilters) {
      apiUrl += '?' + URL_SERVICE_INSTANCE.serialize({filters: this.timelineFilters}) + '&loadPanelOnly=true';
    }

    this.cancelToken.cancel();
    this.cancelToken = Axios.CancelToken.source();

    // Create a Timeline based on our settings
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.TimelineDto>(
        apiUrl,
        {cancelToken: this.cancelToken.token}
    ).then(
        (result: AxiosResponse<DisguiseDto.TimelineDto>) => {
          this.reloadFilterPanel(result.data);
          Vue.nextTick(() => {
            this.loading = false;
            this.initialLoadCompleted = true;
          });
        }, (error) => {
          if (!error || !error.__CANCEL__) {
            this.$store.commit('showSnack', {
              message: 'Datenabruf fehlgeschlagen.',
              color: 'error'
            });
            this.loading = false;
            this.initialLoadCompleted = true;
          }
        });
  }


  private reloadFilterPanel(apiResponse: DisguiseDto.TimelineDto) {
    this.filterConfiguration = apiResponse.filter || [];
    const filterInputConfiguration: DisguiseDto.TimelineFilterDto[] = [];
    for (const currentFilter of apiResponse.filter || []) {
      // we need to merge the original filter values into the newly acquired filter configuration
      // otherwise we lose what was set prior to this reload
      let originalFilterValue = currentFilter.defaultValue;
      for (const originalTimelineFilter of (this.timelineFilters || [])) {
        if (originalTimelineFilter.filterId === currentFilter.filterId
            && originalTimelineFilter.value && originalTimelineFilter.value !== '') {
            originalFilterValue = originalTimelineFilter.value;
            break;
        }
      }
      filterInputConfiguration.push({
        filterId: currentFilter.filterId,
        value: originalFilterValue
      });
    }

    this.timelineFilters = filterInputConfiguration;
    if (apiResponse.panels) {
      this.panels = apiResponse.panels;
    }
    if ((apiResponse.panels || {}).north !== undefined) {
      Vue.nextTick(() => {
        const resizeSensor = new ResizeSensor(this.$refs.northPanel, () => {
          this.resizeNorth();
          this.resizeSouth();
        });
      });
    }

    // Update the filters on the originalApiResponse, as this might be used in later functionalities
    if (this.originalApiResponse) {
      this.originalApiResponse.panels = apiResponse.panels;
      this.originalApiResponse.filter = apiResponse.filter;
    } else {
      this.originalApiResponse = apiResponse;
    }

  }

}
